import "core-js/modules/es.array.concat.js";
import { preUrl, ajaxPreUrl, isProd, livePreUrl } from '@/config';
export var API_GET_RECOMMEND_LIST = "".concat(ajaxPreUrl, "/performances");
export var API_GET_SHOW_RECOMMEND_LIST = "".concat(ajaxPreUrl, "/recommend/performances");
export var API_NEW_GET_RECOMMEND_LIST = "".concat(ajaxPreUrl, "/search");
export var API_GET_HOTSHOP_LIST = "".concat(ajaxPreUrl, "/hotShop/hotShopList?");
export var API_GET_BANNER_LIST = "".concat(ajaxPreUrl, "/advertisements");
export var API_GET_BATCHFETCH_LIST = "".concat(ajaxPreUrl, "/advertisements/batchFetch?");
export var API_GET_YELLOW_STRIP = "".concat(ajaxPreUrl, "/yellowStrip/query");
export var API_GET_POSITION_DETAIL = "".concat(ajaxPreUrl, "/position/detail");
export var API_GET_AD_DETAIL = "".concat(ajaxPreUrl, "/ad/detail");
export var API_GET_PERFORMANCE_DETAIL = "".concat(ajaxPreUrl, "/performances/detailInfo");
export var API_GET_TODAT_LIST = "".concat(ajaxPreUrl, "/performances/rob/main");
export var API_GET_ARTIST_LIST = "".concat(ajaxPreUrl, "/celebrityBasicList/query");
export var API_GET_CONFIG = "".concat(ajaxPreUrl, "/config/maoyan-show-m-web.frontEnd.config.adCityIdList");
export var API_TOP_LIST = "".concat(ajaxPreUrl, "/ranks");
export var API_TOP_DETAIL = function API_TOP_DETAIL(rankId) {
  return "".concat(ajaxPreUrl, "/ranks/").concat(rankId);
};
export var API_TOP_CATEGORY = "".concat(ajaxPreUrl, "/algoBillBoard/category/list");
export var API_TOP_SHOWS_LIST = "".concat(ajaxPreUrl, "/algoBillBoard/performance/list"); // 品牌馆

export var API_GET_BRAND_LIST = "".concat(ajaxPreUrl, "/brand/query");
export var API_GET_BRAND_DETAIL = "".concat(ajaxPreUrl, "/brand");
export var API_GET_CALENDAR_LIST = "".concat(ajaxPreUrl, "/performances/calendar");
export var API_GET_NAV_LIST = "".concat(ajaxPreUrl, "/performance/navigation?");
export var API_GET_ADS_LIST = 'https://ad.maoyan.com/api/position/detail'; // 答题获取列表

export var API_GET_QUESTION_LIST = "".concat(ajaxPreUrl, "/question/queryQuestions");
export var API_GET_QUESTION_LIST_NEW = "".concat(ajaxPreUrl, "/question/queryQuestion");
export var API_SUBMIT_ANSWER = "".concat(ajaxPreUrl, "/question/validateQuestion"); // 粉丝购票

export var API_FANS_BUY = "".concat(ajaxPreUrl, "/fansSignUp/"); // 详情

export var API_GET_DETAIL = function API_GET_DETAIL(performanceId) {
  return "".concat(ajaxPreUrl, "/performance/").concat(performanceId);
}; // 详情推荐项目

export var API_GET_RECOMMAND = function API_GET_RECOMMAND(performanceId) {
  return "".concat(ajaxPreUrl, "/performance/recommends/").concat(performanceId);
}; // 场馆详情

export var API_GET_GROUPS = function API_GET_GROUPS(_ref) {
  var shopId = _ref.shopId,
      pageNo = _ref.pageNo,
      pageSize = _ref.pageSize;
  return "".concat(ajaxPreUrl, "/shop/groups?shopId=").concat(shopId, "&pageNo=").concat(pageNo, "&pageSize=").concat(pageSize);
}; // 缺货登记，票档+场次接口

export var API_GET_SHOWS = function API_GET_SHOWS(performanceId) {
  return "".concat(ajaxPreUrl, "/v2/performance/").concat(performanceId, "/shows/1");
};
export var API_GET_TICKETS = function API_GET_TICKETS(showId) {
  return "".concat(ajaxPreUrl, "/v2/show/").concat(showId, "/tickets/");
};
export var API_POST_REGISTER = "".concat(ajaxPreUrl, "/stockout/register"); // 收藏

export var API_GET_COLLECT_STATE = "".concat(ajaxPreUrl, "/newFavor/loadFavor");
export var API_ADD_COLLECT = "".concat(ajaxPreUrl, "/newFavor/addFavor");
export var API_DEL_COLLECT = "".concat(ajaxPreUrl, "/newFavor/cancelFavor");
export var API_GET_COLLECT_LIST = "".concat(ajaxPreUrl, "/newFavor/favors");
export var API_SAVE_SALE_REMIND_INFO = "".concat(ajaxPreUrl, "/messagepush/save");
export var API_GET_NEED_ANSWER = function API_GET_NEED_ANSWER(performanceId) {
  return "".concat(ajaxPreUrl, "/question/queryQuestion?performanceId=").concat(performanceId, "&count=3");
};
export var API_FANS_BUY_PERFORMANCE = "".concat(ajaxPreUrl, "/signUpActivityInfo/");
export var API_VERIFY_CODE = "".concat(ajaxPreUrl, "/fansSendCode/");
export var API_GET_SHOP_DETAIL = function API_GET_SHOP_DETAIL(shopId) {
  return "".concat(ajaxPreUrl, "/shop/detail?shopId=").concat(shopId);
};
export var API_GET_PRODUCTS_IN_SHOP = function API_GET_PRODUCTS_IN_SHOP(_ref2) {
  var shopId = _ref2.shopId,
      _ref2$pageNo = _ref2.pageNo,
      pageNo = _ref2$pageNo === void 0 ? 1 : _ref2$pageNo,
      _ref2$pageSize = _ref2.pageSize,
      pageSize = _ref2$pageSize === void 0 ? 10 : _ref2$pageSize;
  return "".concat(ajaxPreUrl, "/shop/performances?shopId=").concat(shopId, "&pageNo=").concat(pageNo, "&pageSize=").concat(pageSize);
}; // 团购列表

export var API_GET_GROUP_LIST = function API_GET_GROUP_LIST(_ref3) {
  var _ref3$cityId = _ref3.cityId,
      cityId = _ref3$cityId === void 0 ? 1 : _ref3$cityId,
      _ref3$pageNo = _ref3.pageNo,
      pageNo = _ref3$pageNo === void 0 ? 1 : _ref3$pageNo,
      _ref3$pageSize = _ref3.pageSize,
      pageSize = _ref3$pageSize === void 0 ? 15 : _ref3$pageSize;
  return "".concat(ajaxPreUrl, "/group/discountList?cityId=").concat(cityId, "&pageNo=").concat(pageNo, "&pageSize=").concat(pageSize);
};
export var API_GET_SESSIONS = function API_GET_SESSIONS(performanceId) {
  return "".concat(ajaxPreUrl, "/v2/performance/").concat(performanceId, "/shows/1");
};
export var API_GET_AREAS = function API_GET_AREAS(showId) {
  return "".concat(ajaxPreUrl, "/show/").concat(showId, "/areas");
};
export var API_GET_LINA_BY_KEY = function API_GET_LINA_BY_KEY(key) {
  return "//lina.".concat(isProd ? 'dian' : '51', "ping.com/api/get?key=").concat(key);
}; // 王者荣耀资格校验

export var API_KING_HONOR_CHECK = "".concat(ajaxPreUrl, "/token/validate"); // 获取所有省市区信息

export var API_GET_ALL_REGION = "".concat(ajaxPreUrl, "/region/allRegion"); // 收货地址服务

export var API_GET_ALL_ADDRESSLIST = "".concat(ajaxPreUrl, "/V2/address/allAddressList"); // 查询全部收获地址

export var API_GET_ADDRESSBYID = "".concat(ajaxPreUrl, "/V2/address/getAddressById"); // 根据recipientAddressId获取用户收货地址

export var API_SAVE_ADDRESS = "".concat(ajaxPreUrl, "/V2/address/saveAddress"); // 保存或更新收货地址

export var API_DELETE_ADDRESSBYID = "".concat(ajaxPreUrl, "/address/deleteAddress"); // 根据recipientAddressId删除用户收货地址

export var API_SEARCH_ADDRESS = "".concat(ajaxPreUrl, "/V2/address/queryAddress"); // 根据关键字搜索地址

export var API_DEFAULT_ADDRESS = "".concat(ajaxPreUrl, "/V2/address/defaultAddress"); // 查询默认收货地址
// 实名制相关服务

export var API_GET_ALL_REALNAME_USER_LIST = "".concat(ajaxPreUrl, "/realName/allRealNameUserList"); // 获取已保存的实名用户列表

export var API_SAVE_REALNAME_USER = "".concat(ajaxPreUrl, "/realName/saveRealNameUser"); // 保存实名用户信息

export var API_DELETE_REALNAME_USER = "".concat(ajaxPreUrl, "/realName/deleteRealNameUser"); // 删除实名用户信息

export var API_GET_REALNAME_LIMIT = "".concat(ajaxPreUrl, "/realName/getRealNameLimit"); // 获取单个演出的实名制限购信息

export var API_GET_REALNAME_IDTYPE = "".concat(ajaxPreUrl, "/realName/queryIdType"); // 获取实名制证件类型

export var API_SAVE_BUYERINFO_USER = "".concat(ajaxPreUrl, "/buyer/save"); //保存用户购票人信息
// m站预览

export var API_GET_MSITE_PLAFORMS = function API_GET_MSITE_PLAFORMS(pId) {
  return "".concat(ajaxPreUrl, "/v2/performance/").concat(pId, "/canSellChannelList");
};
export var API_GET_QRCODE = function API_GET_QRCODE(width, path, pid, utm) {
  // return `${ajaxPreUrl}/boostTask/boostShareQRCodeImage?width=${width}&page=${encodeURIComponent( path )}&scene=${encodeURIComponent( `id=${pid}&utm_source=${utm}` )}&appId=wxdbb4c5f1b8ee7da1`
  var url = "".concat(ajaxPreUrl, "/boostTask/boostShareQRCodeImage?width=").concat(width, "&page=").concat(encodeURIComponent(path), "&scene=").concat(encodeURIComponent("id=".concat(pid, "&utm_source=").concat(utm)), "&appId=wxdbb4c5f1b8ee7da1");
  return url;
}; // 女神节活动

export var API_POST_SUBMIT_TEST = "".concat(ajaxPreUrl, "/GirlsDay/QuestionResult");
export var API_POST_QR_IMAGE = "".concat(ajaxPreUrl, "/GirlsDay/SavePicture"); // 报名活动信息

export var API_POST_PLAYER_INFO = "".concat(ajaxPreUrl, "/enrollActivity/contestant/queryItem"); // 出行攻略

export var API_GET_GUIDE = function API_GET_GUIDE(shopId) {
  return "".concat(ajaxPreUrl, "/v2/performance/").concat(shopId, "/travelGuide");
}; // 视频剧照列表

export var API_GET_VIDEO_AND_PHOTO = "".concat(ajaxPreUrl, "/v2/performance/getWrapList"); // 先付先抢

export var API_GET_ORDERLIST = "".concat(ajaxPreUrl, "/prepay/getQueueInfo"); // 第三方小程序授权

export var API_GET_AUTHORIZATION_URL = "".concat(ajaxPreUrl, "/authorization/url"); // LOL校验是否有购买权限

export var API_POST_LOL_CHECK = "".concat(ajaxPreUrl, "/token/validate"); // 订单详情

export var ORDER_DETAIL_URL = function ORDER_DETAIL_URL(orderId) {
  return "".concat(ajaxPreUrl, "/order/detail/v2/").concat(orderId);
};
export var INVOICE_DETAIL_URL = function INVOICE_DETAIL_URL(orderId) {
  return "".concat(ajaxPreUrl, "/invoice/").concat(orderId);
};
export var INVOICE_APPLY_URL = "".concat(ajaxPreUrl, "/invoice/apply");
export var ADMISSION_RECORD_URL = function ADMISSION_RECORD_URL(orderTicketId) {
  return "".concat(ajaxPreUrl, "/ticketCheck?orderTicketId=").concat(orderTicketId);
};
export var ADMISSION_CLIP_RECORD_URL = function ADMISSION_CLIP_RECORD_URL(ticketClipId) {
  return "".concat(ajaxPreUrl, "/ticketClipCheck?ticketClipId=").concat(ticketClipId);
}; // 上传退票/换票凭证申请

export var API_SUBMIT_REFUND_INFO = "".concat(ajaxPreUrl, "/order/refundApply"); // 艺人主页基础信息

export var CELE_BASIC = "".concat(ajaxPreUrl, "/celebrityBasicInfo/query"); // 艺人主页资源位

export var CELE_RESOURCE = "".concat(ajaxPreUrl, "/celebrityResource/query"); // 艺人巡演信息

export var CELE_TOUR = "".concat(ajaxPreUrl, "/celebrityTourGroup/query"); // 艺人其他演出信息

export var CELE_PERFORMANCE = "".concat(ajaxPreUrl, "/celebrityOtherProject/query"); // 艺人精彩演出视频

export var CELE_VIDEO = "".concat(ajaxPreUrl, "/celebrityVideo/query"); // 获取关注状态

export var CELE_FOLLOW_STATUS = "".concat(ajaxPreUrl, "/newFavor/loadFavor"); // 关注艺人

export var CELE_FOLLOW = "".concat(ajaxPreUrl, "/newFavor/addFavor"); // 取消关注艺人

export var CELE_CANCEL_FOLLOW = "".concat(ajaxPreUrl, "/newFavor/cancelFavor"); // 今日必抢列表接口

export var API_GET_TODAY_LIST = "".concat(ajaxPreUrl, "/performances/today/rob");
export var API_GET_DISCOUNT_LIST = "".concat(ajaxPreUrl, "/performances/flash/sale");
export var API_GET_WEEK_LIST = "".concat(ajaxPreUrl, "/performances/week/sale");
export var API_GET_MORE_LIST = "".concat(ajaxPreUrl, "/performances"); // 注销

export var API_LOG_OUT = isProd ? 'https://show.maoyan.com/maoyansh/myshow/m/logout' : 'http://show.test.maoyan.com/maoyansh/myshow/m/logout'; // LOL 新校验是否有购买权限

export var API_POST_NEW_LOL_CHECK = "".concat(ajaxPreUrl, "/event/qualification/validate"); // 查询游戏侧项目活动信息

export var API_GET_ACTIVITY_PROJECT = "".concat(ajaxPreUrl, "/event/activityProject/load");
export var API_GET_ACTIVITY = "".concat(ajaxPreUrl, "/config/maoyan-show-m-web.frontEnd.config.activity"); // kpl lion前端配置

export var API_GET_KPLACTIVITY = "".concat(ajaxPreUrl, "/config/maoyan-show-m-web.frontEnd.config.kplActivity"); // 前端动态配置lion

export var API_GET_ACTIVECONFIG = "".concat(ajaxPreUrl, "/config/maoyan-show-m-web.frontEnd.config.gameMiddlePage"); // Lion 前端 config 通用前缀

export var LION_FRONEND_CONFIG_PREFIX = "".concat(ajaxPreUrl, "/config/maoyan-show-m-web.frontEnd.config."); // 项目公告提示

export var PROJECT_POPUP_URL = "".concat(livePreUrl, "/project/popup"); // 评论

export var COMMENT_SUBMIT = "".concat(livePreUrl, "/comment/submit"); // 提交评论

export var COMMENT_DRAFT_LOADDRAFT = "".concat(livePreUrl, "/comment/draft/loadDraft"); // 加载草稿

export var COMMENT_LOADCOMMENT = "".concat(livePreUrl, "/comment/loadComment"); // 加载评论

export var COMMENT_DRAFT_SAVE = "".concat(livePreUrl, "/comment/draft/save"); // 保存草稿

export var FAVOR_LOAD = "".concat(livePreUrl, "/favor/load"); // 获取单个收藏

export var FAVOR_CANCELFAVOR = "".concat(livePreUrl, "/favor/cancelFavor"); // 删除单个收藏

export var FAVOR_ADDFAVOR = "".concat(livePreUrl, "/favor/addFavor"); // 添加单个收藏

export var COMMENT_PROJECT_PAGEQUERY = "".concat(livePreUrl, "/comment/project/pageQuery"); // 项目评论列表分页查询接口

export var COMMENT_PROJECT_MYCOMMENTS = "".concat(livePreUrl, "/comment/project/myComments"); // 项目下用户评论列表分页接口

export var COMMENT_PROJECT_HOTCOMMENT = "".concat(livePreUrl, "/comment/project/hotComment"); // 热门评论

export var WXAPP_QRCODE = "".concat(livePreUrl, "/wxapp/qrcode"); // 微信二维码

export var COMMENT_ENTRANCE_INFO = "".concat(livePreUrl, "/comment/order/entranceInfo"); // 微信二维码

export var SHARE_CALLBACK = "".concat(livePreUrl, "/forward/project"); // 分享回调
// 品类页面改版新接口

export var matchFeatureUrl = "".concat(ajaxPreUrl, "/matchFeature"); //判断用户是否命中灰度

export var channelPageModuleUrl = "".concat(ajaxPreUrl, "/channelPage/module"); //查询频道页分类模块基础信息

export var channelPageFloorPerfsUrl = "".concat(ajaxPreUrl, "/channelPage/floorPerfs"); //查询频道页分类楼层项目信息

export var channelPageArtsUrl = "".concat(ajaxPreUrl, "/channelPage/celebrity"); //查询艺人大咖

export var channelPageArtsInfoUrl = "".concat(ajaxPreUrl, "/channelPage/celebrityProject"); //查询艺人大咖

export var channelPageBrandUrl = "".concat(ajaxPreUrl, "/channelPage/brand"); //品牌馆

export var channelPageWonderPerfsUrl = "".concat(ajaxPreUrl, "/channelPage/wonderPerfs"); //查询频道页分类精彩演出信息